export const modalClasses = {
  root: 'modal-root',
  backdrop: 'modal-backdrop',
  container: 'modal-container',
  content: 'modal-content',
  header: 'modal-header',
  title: 'modal-title',
  closeButton: 'modal-close-button',
  closeIcon: 'modal-close-icon',
  body: 'modal-body',
  footer: 'modal-footer',
  backButton: 'modal-back-button',
  backIcon: 'modal-back-icon',
  submitButton: 'modal-submit-button',
  secondaryButton: 'modal-secondary-button',
} as const;
